import { useEffect, useState } from "react";

export default (names: string[], deps = [] as ReadonlyArray<any>) => {
  const [state, setState] = useState<PermissionState[]>([]);
  useEffect(() => {
    const container = { unmount: [] as any[] };
    (async function () {
      try {
        const results = await Promise.all(names.map((n) => navigator.permissions.query({ name: n as PermissionName })));
        for (let i = 0; i < results.length; i++) {
          const changeCallback = (ev: Event) => {
            setState((prev) => {
              const next = [...prev];
              next[i] = (ev.target as PermissionStatus).state;
              return next;
            });
          };
          results[i].addEventListener("change", changeCallback);
          container.unmount.push(() => results[i].removeEventListener("change", changeCallback));
        }
        setState(results.map((result) => result.state));
      } catch {
        // Firefox doesn't support many permissions, so just assume they are granted
        setState(names.map(() => "granted"));
      }
    })();
    return () => void container.unmount.forEach((fn) => fn());
  }, deps);
  return state;
};
